import { Checkbox, MenuItem, Select } from '@mui/material';
import { FC } from 'react';

import type { CustomFieldValueType } from '@vy/custom-fields-types';

import { ClickToEditTextCell } from './ClickToEditTextCell';

type EditableCustomFieldValueCellProps = {
  value: string | number | boolean | null | undefined;
  valueType: CustomFieldValueType;
  onCommit: (next: string | number | boolean | null) => void;
  onBlur?: () => void;
  dataVyPrefix: string;
  showConfirmButtons?: boolean;
  allowedValues?: string[];
};

const noop = () => {
  // default onBlur for consumers that don't need the signal
};

export const EditableCustomFieldValueCell: FC<EditableCustomFieldValueCellProps> = ({
  value,
  valueType,
  onCommit,
  onBlur = noop,
  dataVyPrefix,
  showConfirmButtons = false,
  allowedValues = [],
}) => {
  if (valueType === 'Boolean') {
    return (
      <Checkbox
        data-vy={`${dataVyPrefix}-checkbox`}
        checked={value === true}
        onChange={(event) => onCommit(event.target.checked)}
        onBlur={onBlur}
      />
    );
  }

  if (valueType === 'Enum') {
    return (
      <Select
        data-vy={`${dataVyPrefix}-select`}
        value={typeof value === 'string' ? value : ''}
        onChange={(event) => onCommit(event.target.value)}
        onBlur={onBlur}
        size="small"
        displayEmpty
        sx={{ minWidth: 120 }}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {allowedValues.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <ClickToEditTextCell
      valueType={valueType as 'String'}
      value={value}
      onCommit={onCommit}
      onBlur={onBlur}
      dataVyPrefix={dataVyPrefix}
      showConfirmButtons={showConfirmButtons}
    />
  );
};
